import React, { Component } from "react";
import ApprovalInformation from "../../Common/ApprovalInformation";
import { main_url, getBranch, fno } from "../../../utils/CommonFunction";
import DocumentList from "../../Common/DocumentList";
import Select from "react-select";
import EamPaymentApprovalInformation from "../../Common/EamPaymentApprovalInformation";
import { getHeaders } from "../../../utils/apiHelper";

class WeddingBenefitView extends Component {
  constructor(props) {
    super(props);
    this.state = {
      datasource: this.props.data,
      status_info: [],
      document: [],
      selected_location: [], //Added by STHA
      branch: [], //Added by STHA
      eamPaymentDetailsInfo: [],
    };
  }

  async componentDidMount() {
    this.getStatusInfo();
    this.getDocument();
    this.getAllBranches();
    this.getEamPaymentInfo();
  }

  //Added by STHA to get EAM Payment Info
  getEamPaymentInfo() {
    let form_no = this.state.datasource.form_no; // Form Number
    let type = "Wedding";
    fetch(`${main_url}eam_payment/getEamPaymentInfo/${form_no}/${type}`, {
      headers: getHeaders(),
    })
      .then((res) => res.json())
      .then((res) => {
        this.setState({
          eamPaymentDetailsInfo: res,
        });
      })
      .catch((error) => console.log(error));
  }

  //Added by STHA
  async getAllBranches() {
    let branch = await getBranch();
    let selected_location = this.getSelectedLocation(
      branch,
      this.props.data.withdraw_location
    );
    this.setState({
      branch: branch,
      selected_location: selected_location,
    });
  }

  //Added by STHA
  getSelectedLocation(branch, location) {
    let selected = branch.filter(function (b) {
      return b.value === location;
    });
    return selected;
  }

  getStatusInfo() {
    fetch(
      `${main_url}wedding_benefit/getOneDetailInfo/${this.state.datasource.benefit_id}`, {
        headers: getHeaders(),
      }
    )
      .then((res) => res.json())
      .then((res) => {
        this.setState({
          status_info: res,
        });
      })
      .catch((error) => console.log(error));
  }

  getDocument() {
    fetch(
      `${main_url}wedding_benefit/getDocument/${this.state.datasource.benefit_id}`, {
        headers: getHeaders(),
      }
    )
      .then((res) => res.json())
      .then((res) => {
        this.setState({
          document: res,
        });
      })
      .catch((error) => console.log(error));
  }

  render() {    
    return (
      <div className="container">
        <div className="row">
          <form>
            <div className="row">
              <div className="form-group col-md-6">
                <div>
                  <label htmlFor="employee-name" className="col-sm-12">
                    Voucher No.
                  </label>
                </div>
                <div className="col-sm-10">
                  <input
                    type="text"
                    disabled
                    className="form-control"
                    value={fno.fno_wedding + this.state.datasource.form_no}
                  />
                </div>
              </div>
              <div className="form-group col-md-6">
                <div>
                  <label htmlFor="designation" className="col-sm-12">
                    Branch
                  </label>
                </div>
                <div className="col-sm-10">
                  <input
                    type="text"
                    className="form-control"
                    value={this.state.datasource.branch_name}
                    disabled
                  />
                </div>
              </div>
            </div>
            <div className="row">
              <div className="form-group col-md-6">
                <div>
                  <label htmlFor="employee-name" className="col-sm-12">
                    Employee Name
                  </label>
                </div>
                <div className="col-sm-10">
                  <input
                    type="text"
                    disabled
                    className="form-control"
                    value={this.state.datasource.employee_name}
                  />
                </div>
              </div>
              <div className="form-group col-md-6">
                <div>
                  <label htmlFor="designation" className="col-sm-12">
                    Designation
                  </label>
                </div>
                <div className="col-sm-10">
                  <input
                    type="text"
                    className="form-control"
                    value={this.state.datasource.designations}
                    disabled
                  />
                </div>
              </div>
            </div>
            <div className="row">
              <div className="form-group col-md-6">
                <div>
                  <label htmlFor="employee-name" className="col-sm-12">
                    Is Your Spouse An Alliance Staff ?
                  </label>
                </div>
                <div className="col-sm-10">
                  <input
                    type="text"
                    disabled
                    value={
                      this.state.datasource.is_alliance_staff === 1
                        ? "Yes"
                        : "No"
                    }
                    className="form-control"
                  />
                </div>
              </div>
              <div className="form-group col-md-6">
                <div>
                  <label htmlFor="spouse-name" className="col-sm-12">
                    Spouse Name
                  </label>
                </div>
                <div className="col-sm-10">
                  <input
                    type="text"
                    disabled
                    className="form-control"
                    value={!!this.state.datasource.spouse_display_employment_id 
                      ? `${this.state.datasource.spouse_display_employment_id} ${this.state.datasource.spouse_display_name} ( ${this.state.datasource.spouse_display_designation} - ${this.state.datasource.spouse_display_branch} )`
                      : this.state.datasource.spouse_display_name
                    }
                  />
                </div>
              </div>
            </div>
            <div className="row">
              <div className="form-group col-md-6">
                <div>
                  <label htmlFor="available_amount" className="col-sm-12">
                    Available Amount{" "}
                  </label>
                </div>
                <div className="col-sm-10">
                  <input
                    type="number"
                    disabled
                    value={this.state.datasource.available_amount}
                    className="form-control"
                  />
                </div>
              </div>

              {/* Added by STHA */}
              <div className="col-md-6 form-group">
                <div>
                  <label className="col-sm-12">
                    WithDraw Location<span className="text-danger">*</span>
                  </label>
                </div>
                <div className="col-sm-10">
                  <Select
                    data-name="withdraw_loction"
                    value={this.state.selected_location}
                    isDisabled={true}
                    // onChange={this.changeWithdrawLocation}
                    // options={this.state.branch}
                    className="react-select-container checkValidate"
                    classNamePrefix="react-select"
                  />
                </div>
              </div>
              {/* Added end by STHA */}
            </div>
            <div className="row document-main">
              {this.state.document.length > 0 ? (
                <DocumentList
                  title="Wedding Benefit Document"
                  doc={this.state.document}
                  path="wedding_benefit"
                />
              ) : (
                ""
              )}
            </div>
            {!Array.isArray(this.state.status_info) ? (
              <div className="row approval-main margin-top-20">
                <ApprovalInformation status={this.state.status_info} />
                {this.state.eamPaymentDetailsInfo &&
                  this.state.eamPaymentDetailsInfo.length > 0 && (
                    <EamPaymentApprovalInformation
                      eamPaymentDetailsInfo={this.state.eamPaymentDetailsInfo}
                    />
                  )}
              </div>
            ) : (
              ""
            )}
          </form>
        </div>
      </div>
    );
  }
}

export default WeddingBenefitView;
